<template>
  <div>
    <!-- 已勾选数据 -->
    <h4 class="contain-physical-title-style">
      有实物产品
    </h4>
    <el-table
      :data="containPhysicalDataList"
      style="width: 100%"
      border
      show-summary
      sum-text="有实物合计"
      :summary-method="getTotal"
      :row-class-name="setCheckBoxHiddenOrVisible"
    >
      <el-table-column width="50" label="序号" align="left" fixed="left" type="index" />
      <el-table-column width="150" label="合同号" align="left" prop="contractNum" />
      <!-- <el-table-column
        prop="orderlinId"
        label="Order Line Id"
        align="left"
        min-width="120"
      /> -->
      <el-table-column min-width="220" label="物品代码" align="left" prop="materialNumber" />
      <el-table-column min-width="220" label="物品名称" align="left" prop="productName" />
      <el-table-column
        label="未发货数量"
        align="left"
        prop="unshipQuantity"
        width="90"
      >
        <template v-slot="{row}">
          {{ row.unshipQuantity && Number(row.unshipQuantity).toFixed(0) }}
        </template>
      </el-table-column>
      <el-table-column
        label="实际结算单价"
        align="right"
        header-align="left"
        prop="productPriceSigle"
        width="140"
      >
        <template v-slot="{row}">
          {{ row.productPriceSigle && Number(row.productPriceSigle).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="amountSum"
        label="实际结算金额"
        align="right"
        header-align="left"
        width="140"
      >
        <template v-slot="{row}">
          {{ row.amountSum && Number(row.amountSum).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column width="180" label="客户期望发货日" align="left" prop="expectedDeliveryDate" />
      <el-table-column width="180" label="约定交付日期" align="left" prop="agreedDate" />
      <el-table-column width="180" label="整改后交期" align="left" prop="deliveryDateAfterRectification" />
      <el-table-column
        prop="physicalFlag"
        label="是否实物"
        align="left"
        width="80"
      >
        <template v-slot="{row}">
          {{ row.physicalFlag ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="batteryFlag"
        label="是否带电池"
        align="left"
        width="80"
      >
        <template v-slot="{row}">
          {{ row.batteryFlag ? '是' : '否' }}
        </template>
      </el-table-column>

      <el-table-column
        width="150"
        label="预估体积(m³)"
        align="left"
      >
        <template v-slot="{row}">
          <span v-if="row.index !== '小计'">
            {{ getVolume(row)||'——' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="warehouse"
        label="仓位"
        align="left"
        min-width="120"
      />
      <el-table-column
        width="150"
        label="预估重量(kg)"
        align="left"
      >
        <template v-slot="{row}">
          <span v-if="row.index !== '小计'">
            {{ getWeight(row) ||'——' }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <h4 class="not-contain-physical-title-style">
      无实物产品
    </h4>
    <!-- 第二个表格 -->
    <el-table
      :data="notContainPhysicalDataList"
      style="width: 100%"
      border
      show-summary
      sum-text="合计"
      :summary-method="getTotal"
      :row-class-name="setCheckBoxHiddenOrVisible"
    >
      <el-table-column width="50" label="序号" align="left" type="index" fixed="left" />
      <el-table-column width="150" label="合同号" align="left" prop="contractNum" />
      <!-- <el-table-column
        prop="orderlinId"
        label="Order Line Id"
        align="left"
        min-width="120"
      /> -->
      <el-table-column min-width="220" label="物品代码" align="left" prop="materialNumber" />
      <el-table-column min-width="220" label="物品名称" align="left" prop="productName" />
      <el-table-column
        label="未发货数量"
        align="left"
        prop="unshipQuantity"
        width="90"
      >
        <template v-slot="{row}">
          {{ row.unshipQuantity && Number(row.unshipQuantity).toFixed(0) }}
        </template>
      </el-table-column>
      <el-table-column
        label="实际结算单价"
        align="right"
        header-align="left"
        prop="productPriceSigle"
        width="140"
      >
        <template v-slot="{row}">
          {{ row.productPriceSigle && Number(row.productPriceSigle).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="amountSum"
        label="实际结算金额"
        align="right"
        header-align="left"
        width="140"
      >
        <template v-slot="{row}">
          {{ row.amountSum && Number(row.amountSum).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column width="180" label="客户期望发货日" align="left" prop="expectedDeliveryDate" />
      <el-table-column width="180" label="约定交付日期" align="left" prop="agreedDate" />
      <el-table-column width="180" label="整改后交期" align="left" prop="deliveryDateAfterRectification" />
      <el-table-column
        prop="physicalFlag"
        label="是否实物"
        align="left"
        width="80"
      >
        <template v-slot="{row}">
          {{ row.physicalFlag ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="batteryFlag"
        label="是否带电池"
        align="left"
        width="80"
      >
        <template v-slot="{row}">
          {{ row.batteryFlag ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        label="预估体积(m³)"
        align="left"
      >
        <template v-slot="{row}">
          <span v-if="row.index !== '小计'">
            {{ getVolume(row)||'——' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="warehouse"
        label="仓位"
        align="left"
        min-width="120"
      />
      <el-table-column
        width="150"
        label="预估重量(kg)"
        align="left"
      >
        <template v-slot="{row}">
          <span v-if="row.index !== '小计'">
            {{ getWeight(row) ||'——' }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 总计 -->
    <div class="summary-row el-table__footer">
      <table>
        <tfoot>
          <tr>
            <td>合计</td>
            <td>{{ Number(totalAllQuantity).toFixed(2) }}</td>
            <td>{{ Number(totalAllAmountSum).toFixed(2) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <!-- 表单信息 -->
    <el-form ref="dialogForm" :model="dialogForm" :rules="rules" label-width="120px" @close="clearAll">
      <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
        地址信息
      </div>
      <el-row>
        <el-col>
          <el-form-item prop="addressInfo">
            <span slot="label">收货地址</span>
            <el-select
              v-model="dialogForm.addressInfo"
              class="addressSelect"
              placeholder="请选择收货地址"
              clearable
            >
              <el-option v-for="item in addressInfo" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col />
        <el-col />
      </el-row>
      <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
        海外备件仓地址
      </div>
      <el-row v-loading="isForwarderLoading">
        <!-- <el-col :span="10">
          <el-form-item label="货代信息:" prop="forwarderCode">
            <el-input v-model="dialogForm.forwarderCode" @input="querySearchAsync" />
          </el-form-item>
        </el-col> -->
        <el-col :span="20">
          <el-form-item label="仓库名称:" prop="companyName">
            <el-input v-model="dialogForm.companyName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="联系人:" prop="companyPerson">
            <el-input v-model="dialogForm.companyPerson" />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="联系人电话:" prop="companyTel">
            <el-input v-model="dialogForm.companyTel" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="10">
          <el-form-item label="邮箱:" prop="companyEmail">
            <el-input v-model="dialogForm.companyEmail" />
          </el-form-item>
        </el-col> -->
        <el-col :span="20">
          <el-form-item label="地址:" prop="companyAddress">
            <el-input v-model="dialogForm.companyAddress" maxlength="200" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider />
      <el-row>
        <el-col :span="10">
          <el-form-item label="是否需要唛头:" porp="isNeedShippingMarks">
            <el-radio-group v-model="dialogForm.isNeedShippingMarks">
              <el-radio :label="true">
                是
              </el-radio>
              <el-radio :label="false">
                否
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="授权邮箱:" prop="authorizedEmail">
            <el-button v-show="emailStatu" type="primary" @click="addEmail">
              添加邮箱
            </el-button>
            <!-- <el-input v-show="!emailStatu" v-model="dialogForm.authorizedEmail" class="emailInput" @blur="emailBlur" /> -->
            <el-input v-show="!emailStatu" v-model="currentEamil" class="emailInput" @keyup.enter.native="emailBlur" @blur="emailBlur" @input="debouncedValidateEmail" />
            <span v-show="!isEmailValid&&!emailStatu" class="error-message">请输入有效的邮箱地址</span>
            <span v-show="isEmailValid&&!emailStatu&&authorizationEmailCheck" class="error-message">授权邮箱地址过长，请输入 80 个字符以内的邮箱</span>
            <div>
              <el-tag v-for="item in currentEamilArr" :key="item" class="itemTag" size="small" closable @close="handleClose(item)">
                {{ item }}
              </el-tag>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 是否发货人申请合并发货 -->
      <el-row>
        <el-col :span="10">
          <el-form-item
            label="是否有其它发货单申请合并发货:"
            porp="isConsolidatedShipment"
            class="application-for-combined-shipment-style"
          >
            <el-radio-group
              v-model="dialogForm.isConsolidatedShipment"
              @change="changeConsolidatedShipment"
            >
              <el-radio :label="true">
                是
              </el-radio>
              <el-radio :label="false">
                否
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- <el-col v-if="isShowAssociatedOrderNumber" :span="10">
          <el-form-item
            label="其他发货单申请单号:"
            class="associated-order-number-style"
            prop="associatedOrderNumber"
          >
            <el-input
              v-model="dialogForm.associatedOrderNumber"
              placeholder="请输入其他发货单申请单号"
              maxlength="50"
            />
          </el-form-item>
        </el-col> -->
      </el-row>
      <div style="margin: 20px 0; font-weight: 800; font-size: 18px;">
        发运信息
      </div>
      <el-form-item label="贸易术语:" prop="tradeTerms">
        <el-select v-model="dialogForm.tradeTerms" clearable>
          <el-option v-for="item in chooseTradeterms" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue" />
        </el-select>
      </el-form-item>
      <el-form-item label="包装要求:" prop="packingInstruction">
        <el-select v-model="dialogForm.packingInstruction" clearable>
          <el-option v-for="item in packingrequirement" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue" />
        </el-select>
        <span style="margin-left: 20px">注：选择其他时，线下传递非标申请表</span>
      </el-form-item>
      <el-form-item label="货运方式:" prop="shippingMethod">
        <el-select
          v-model="dialogForm.shippingMethod"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in modeoffreighttransport"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
      </el-form-item>
      <!-- 增加批次选择 -->
      <el-form-item label="批次:">
        <el-select
          v-model="dialogForm.batchNumber"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in batchNumberOptionsData"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <div>
        <attachment-uploading ref="fileRef" :is-upload="true" />
      </div>
      <div style="margin: 15px 0">
        商务发货备注说明：
      </div>
      <el-form-item label-width="auto">
        <el-input v-model="dialogForm.notesOnDelivery" type="textarea" :rows="5" maxlength="1000" placeholder="请输入内容" show-word-limit />
      </el-form-item>
    </el-form>
    <div class="selectedBtnsBox">
      <el-button type="primary" :loading="isSubmitLoading" @click="addAndbReturnlist">
        提交并返回列表
      </el-button>
      <el-button type="primary" :loading="isSubmitLoading" @click="closeDelivergoodsdialog">
        取消申请
      </el-button>
      <!-- 发送关务邮箱  -->
      <template>
        <el-select
          v-model="dialogForm.selectSendEmailNmae"
          class="inter-send-customs-email-style"
          placeholder="请选择发送的邮箱"
          clearable
          @change="changeSalesEmaile"
        >
          <el-option
            v-for="item in selectEmailUserName"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
        <el-checkbox
          v-model="isCheckEmaileNotificationStatus"
          @change="clickEmaileNotificationStatus"
        />
        <span
          class="inter-send-customs-email-tips-style"
        >是否通知审批人</span>
      </template>
    </div>
  </div>
</template>

<script>
import EventBus from '@/libs/eventBus.js';
import { MathAdd } from '@/libs/util';
import { getDictData } from '@/API';
import {
  bgSubmitPartialShipments, // 提交申请
  mailboxVerification, // 校验申请邮箱
  getByForwarderCode,
  contractgetContractNumberByWarehouse
} from '@/API/international';
import AttachmentUploading from '@/views/business/components/AttachmentUploading.vue';
import big from 'big.js';
import { debounce } from '@/libs/util.js';
export default {
  name: 'ApplyForDeliveryDialog',
  components: { AttachmentUploading },
  props: {
    product: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      containPhysicalDataList: [], // 包含实物列表数据
      notContainPhysicalDataList: [], // 不包含实物列表数据
      isForwarderLoading: false,
      emailStatu: true,
      currentEamil: '',
      currentEamilArr: [],
      isEmailValid: true,
      authorizationEmailCheck: false, // 授权邮箱长度校验
      productInfo: [],
      dialogForm: {
        // productInfo: [],
        addressInfo: '', // 收货地址
        companyName: '', // 公司名称
        companyAddress: '', // 地址
        companyPerson: '', // 联系人
        companyTel: '', // 电话
        companyEmail: 'NaNa', // 邮箱
        isNeedShippingMarks: false, // 是否需要唛头
        authorizedEmail: '', // 授权邮箱
        tradeTerms: '', // 贸易术语
        packingInstruction: '', // 包装要求
        shippingMethod: '', // 货运方式
        notesOnDelivery: '', // 发货备注
        selectSendEmailNmae: '', // 通知关务邮箱名称
        isConsolidatedShipment: false, // 是否申请合并发货
        associatedOrderNumber: '', // 合并发货单号
        batchNumber: null // 批次编号
      },
      isSubmitLoading: false,
      // 收获地址
      addressInfo: [],
      // 贸易数语
      IsBoolean: false, // 授权邮箱校验
      chooseTradeterms: [],
      isNoodShippingMark: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ],
      packingrequirement: [], // 包装要求
      modeoffreighttransport: [], // 货运方式
      isCheckEmaileNotificationStatus: false, // 是否选中了通知邮箱状态
      selectEmailUserName: [], // 邮件提醒审批人数据
      batchNumberOptionsData: this.generateOptionsData() // 批次号生成1~99的函数
      // isShowAssociatedOrderNumber: false // 发送关务,是否展示关联单号输入框
    };
  },
  computed: {
    authorizationEmailCount () {
      return this.dialogForm.authorizedEmail ? this.dialogForm.authorizedEmail.length > 80 : false;
    },
    // 表单校验规则
    rules () {
      const validateAuthorizationEmails = (rule, value, callback) => {
        if (this.IsBoolean && !value) {
          callback(new Error('请输入邮箱地址'));
          return;
        }
        if (value && value.length > 80) {
          return;
        }
        callback();
      };
      let rulesConfig = {
        // 收货地址
        addressInfo: [
          { required: true, message: '请选择收货地址', trigger: ['blur', 'change'] }
        ],
        // 仓库名称
        companyName: [
          { required: true, message: '请输入仓库地址', trigger: 'blur' }
        ],
        // 地址
        companyAddress: [
          { required: true, message: '请输入仓库地址', trigger: 'blur' }
        ],
        // 联系人
        companyPerson: [
          { required: true, message: '请选输入联系人', trigger: 'blur' }
        ],
        // 电话
        companyTel: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
          // { min: 11, max: 11, message: '请输入长度为 11位 的手机号', trigger: 'blur' }
        ],
        // 邮箱
        companyEmail: [
          {
            type: 'string',
            required: true,
            message: '请输入邮箱地址',
            trigger: 'blur'
          }
        ],
        // 贸易术语
        tradeTerms: [
          { required: true, message: '请选择贸易术语', trigger: ['blur', 'change'] }
        ],
        // 包装要求
        packingInstruction: [
          { required: true, message: '请选择包装要求', trigger: ['blur', 'change'] }
        ],
        // 货运方式
        shippingMethod: [
          { required: true, message: '请选择货运方式', trigger: ['blur', 'change'] }
        ],
        // 授权邮箱
        authorizedEmail: [
          { required: this.IsBoolean, validator: validateAuthorizationEmails, trigger: ['blur', 'change'] }
          // { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        // 关联单号
        associatedOrderNumber: [
          { required: true, message: '请输入关联单号', trigger: 'blur' }
        ]
      };
      return rulesConfig;
    },
    // 计算总价
    amountSum () {
      let contractNums = [];
      // 数量,总价
      let subtotal = { index: '小计', unshipQuantity: 0, amountSum: 0 };
      this.productInfo.forEach(item => {
        (!contractNums.includes(item.contractNum)) && contractNums.push(item.contractNum);
      });
      contractNums.forEach(contractNum => {
        let filterArray = this.productInfo.filter(item => item.contractNum === contractNum);
        filterArray.forEach(item => {
          subtotal.amountSum = MathAdd(Number(subtotal.amountSum), Number(item.amountSum)); // 总价
        });
      });
      return subtotal.amountSum;
    },
    // 计算总数量
    totalAllQuantity () {
      let total = 0;
      this.containPhysicalDataList.forEach((item) => {
        total = big(total).plus(item.unshipQuantity).toNumber();
      });

      this.notContainPhysicalDataList.forEach((item) => {
        total = big(total).plus(item.unshipQuantity).toNumber();
      });
      return total;
    },

    // 实际结算总金额
    totalAllAmountSum () {
      let total = 0;
      this.containPhysicalDataList.forEach((item) => {
        total = big(total).plus(item.amountSum).toNumber();
      });

      this.notContainPhysicalDataList.forEach((item) => {
        total = big(total).plus(item.amountSum).toNumber();
      });
      return total;
    }

  },
  methods: {
    validateEmail () {
      const emailPattern = /^([a-zA-Z0-9]+[._-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[._-]?)*[a-zA-Z0-9]+(\.[a-zA-Z]{2,})+$/i;
      this.isEmailValid = emailPattern.test(this.currentEamil);
      if (this.isEmailValid && this.dialogForm.authorizedEmail) {
        this.currentEamil.length + this.dialogForm.authorizedEmail.length + 1 > 80 ? this.authorizationEmailCheck = true : this.authorizationEmailCheck = false;
      } else if (this.isEmailValid && this.currentEamil.length > 80) {
        this.authorizationEmailCheck = true;
      } else {
        this.authorizationEmailCheck = false;
      }
    },
    transformationEmailValue () {
      this.currentEamilArr = this.currentEamilArr.filter(item => item);
      this.dialogForm.authorizedEmail = this.currentEamilArr.join(';');
    },
    addEmail () {
      this.emailStatu = false;
    },
    emailBlur () {
      // 立即校验，避免防抖期间回车添加未校验的邮箱
      this.validateEmail();
      if (this.currentEamil && this.isEmailValid && !this.authorizationEmailCheck) {
        this.currentEamilArr.push(this.currentEamil.trim());
        this.currentEamil = '';
        this.transformationEmailValue();
      }
      this.emailStatu = true;
    },
    handleClose (val) {
      this.currentEamilArr.splice(this.currentEamilArr.indexOf(val), 1);
      this.transformationEmailValue();
    },
    getHaveAppliedTableDataListMethods () {
      this.containPhysicalDataList = this.product.filter(item => item.physicalFlag);
      this.notContainPhysicalDataList = this.product.filter(item => !item.physicalFlag);
    },
    // 生成批次,编码1~99的范围数据
    generateOptionsData () {
      const data = [];
      for (let i = 1; i <= 99; i++) {
        data.push({
          id: i,
          value: i,
          label: `${i}`
        });
      }
      return data;
    },
    // 选择关务,发送邮箱通知事件
    changeSalesEmaile (val) {
      if (val) {
        this.dialogForm.selectSendEmailNmae = val;
        this.clickEmaileNotificationStatus();
      } else {
        this.clickEmaileNotificationStatus();
      }
    },
    // 发送通知邮箱,勾选状态
    clickEmaileNotificationStatus (val) {
      if (this.dialogForm.selectSendEmailNmae) {
        this.isCheckEmaileNotificationStatus = true;
      } else {
        this.isCheckEmaileNotificationStatus = false;
      }
    },
    // 选择是否有其他发货单申请合并发货
    changeConsolidatedShipment (val) {
      this.isShowAssociatedOrderNumber = !!val;
    },
    // 预估体积
    getVolume (row) {
      // 检查长度、高度和宽度是否存在且不为空
      // if (!row.length || !row.high || !row.width) {
      //   return null;
      // }
      // let length = big(this.getNumber(row.length)).div(1000);
      // let height = big(this.getNumber(row.high)).div(1000);
      // let width = big(this.getNumber(row.width)).div(1000);
      // let result = (length.times(height).times(width)).toFixed(4);
      // return result;

      // 如果为空: 设置默认值
      if (!row.length || !row.high || !row.width) {
        return '——';
      }
      let length = big(this.getNumber(row.length)).div(big(1000));
      let height = big(this.getNumber(row.high)).div(big(1000));
      let width = big(this.getNumber(row.width)).div(big(1000));
      let quantity = big(this.getNumber(row.unshipQuantity));
      let boxcount = big(this.getNumber(row.boxCnt));
      //  结果乘发货数量  unshipQuantity  再除以装箱数 boxCnt
      return (length.times(height).times(width).times(quantity).div(boxcount)).toFixed(4);
    },
    // 预估重量
    getWeight (row) {
      // 毛重计算公式="未发货数量"/"装箱数"*运输箱重量
      // 未发货数量: unshipQuantity
      // 装箱数: boxCnt
      // 运输箱重量: unitWeight
      if (!row.unshipQuantity || !row.boxCnt || !row.unitWeight || this.getNumber(row.boxCnt) === 0 ||
    this.getNumber(row.unitWeight) === 0) {
        return null;
      }
      const unshippedQuantity = big(this.getNumber(row.unshipQuantity)); // 未发货数量
      const packingQuantity = big(this.getNumber(row.boxCnt)); // 装箱数
      const transportBoxWeight = big(this.getNumber(row.unitWeight)); // 运输箱重量
      return big(unshippedQuantity).div(packingQuantity).times(transportBoxWeight).toFixed(2);
    },
    // 数字转换
    getNumber (value) {
      return Number(value || 0) || 0;
    },
    // 提交并返回列表
    addAndbReturnlist () {
      // 判空
      if (
        this.dialogForm.addressInfo === '' ||
        this.dialogForm.companyAddress === '' ||
        this.dialogForm.companyPerson === '' ||
        this.dialogForm.tradeTerms === '' ||
        this.dialogForm.companyTel === '' ||
        // this.dialogForm.companyEmail === '' ||
        this.packingInstruction === '' ||
        this.shippingMethod === ''
      ) {
        this.$message.error('请完善数据!');
        return;
      };
      if (this.authorizationEmailCount) {
        // this.$message.error('授权邮箱字符串超过80');
        console.error('授权邮箱字符串超过80');
        return;
      }
      this.isSubmitLoading = true;
      let params = {
        addUpdate: 1, // 类型  1 新增 添加 2 修改 编辑
        // 审批发货表
        intelPartialInvoiceInfo: {
          salesType: this.productInfo[0].salesType === '现销' ? 1 : 2, // 现销/赊销 //  外销
          agentId: this.productInfo[0].agentId, // 订货单位ID
          agentName: this.productInfo[0].agentName, // 代理商名称
          salesManCode: '测试外销名称', // 外销 编码 先不传递
          overSeasSalesCountry: this.productInfo[0].overSeasSalesCountry, // 销往国家
          overSeasSalesCountryCode: this.productInfo[0].overSeasSalesCountryCode, // 销往国家编码
          supplyUnitId: this.productInfo[0].supplyUnitId, // 销往国家id
          salesManName: this.productInfo[0].salesManName // 外销字段名称
        },
        // 审批发货详情
        partialInvoiceDetail: {
          department: this.productInfo[0].department, // 部门
          corporateName: this.dialogForm.companyName, // 公司名称
          phoneNumber: this.dialogForm.companyTel, // 电话
          contactName: this.dialogForm.companyPerson, // 联系人
          customerEmail: this.dialogForm.companyEmail, // 邮箱
          markType: this.dialogForm.isNeedShippingMarks, // 是否需要唛头 0否 1是
          packagingRequirements: this.dialogForm.packingInstruction, // 包装要求
          modeOfShipping: this.dialogForm.shippingMethod, // 货运方式
          authorizationEmail: this.dialogForm.authorizedEmail, // 授权邮箱
          corporateAddress: this.dialogForm.companyAddress, // 地址
          deliverRemarkBusiness: this.dialogForm.notesOnDelivery, // 发货备注
          tradeTerms: this.dialogForm.tradeTerms, // 贸易术语
          receiptAddressId: this.dialogForm.addressInfo, // 收货地址
          currencyId: this.productInfo[0].currencyId, // 币种编码       待确认
          currencyName: this.productInfo[0].currencyName, // 币种名称    待确认
          amountSum: this.amountSum, // 实际结算金额
          mergeShip: this.dialogForm.isConsolidatedShipment, // 是否申请合并发货
          mergeNum: this.dialogForm.associatedOrderNumber, // 合并发货单号
          noticeEmail: this.dialogForm.selectSendEmailNmae || '', // 关务通知邮箱
          batchNum: this.dialogForm.batchNumber // 批次号
        },
        fileInfo: this.$refs.fileRef.getFileList()
      };
      // 申请发货产品详情
      params.partialInvoiceProducts = [];
      this.product.forEach((item, index) => {
        params.partialInvoiceProducts.push({
          contractNum: item.contractNum, //  合同号
          orderNumber: item.erpOrderNum, // 订单号
          productName: item.productName, // 产品规格型号
          materialNumber: item.materialNumber, // 料号
          amountSum: item.amountSum, // 实际结算金额
          productNum: Number(item.unshipQuantity), // 未发货数量
          productPriceSigle: item.productPriceSigle, // 产品单价
          expectedDeliveryDate: item.expectedDeliveryDate, // 期望发货日期
          freightProperty: item.freightProperty, // 货运属性
          agreedDate: item.agreedDate, // 约定交付日期
          deliveryDateAfterRectification: item.deliveryDateAfterRectification, // 更改后交付日期
          expectationSendTime: item.expectedDeliveryDate, // 期望发货日期
          // propertyNum: '1', // 属性号  留
          organization: item.organization, // 组织
          warehouse: item.warehouse, // 仓库 库位
          itemIndex: item.orderlinId, // ERPlinID ERP行ID
          erpProductListPrice: item.unitListPrice, // list价
          lineNum: item.lineNum, // 行号
          physicalFlag: item.physicalFlag, // 是否含非实物
          batteryFlag: item.batteryFlag, // 是否含电
          volume: this.getVolume(item), // 预估体积
          accountPeriod: item.accountPeriod, // 账期
          grossWeight: this.getWeight(item), // 预估重量
          serviceDesc: item.serviceDescription
        });
      });
      bgSubmitPartialShipments(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          console.log(data);
          this.$message.success('操作成功');
          EventBus.$emit('clearHaveAppliedTableData', res);
          this.productInfo = [];
          EventBus.$emit('closeDelivergoodsdialog', false);
          this.$refs.dialogForm.resetFields();
          this.claerIpt();
          this.transformationEmailValue();
          this.isSubmitLoading = false;
        } else {
          EventBus.$emit('closeDelivergoodsdialog', true);
          this.isSubmitLoading = false;
          // this.productInfo = [];
        }
      }).catch(() => {
        this.isSubmitLoading = false;
      });
      // this.$refs.dialogForm.resetFields();
      // this.claerIpt();
    },
    claerIpt () {
      this.dialogForm.companyTel = '';
      this.dialogForm.companyEmail = 'NaNa';
      this.dialogForm.notesOnDelivery = '';
    },
    // 取消申请 关闭对话框
    closeDelivergoodsdialog () {
      this.claerIpt();
      this.$refs.dialogForm.resetFields();
      this.transformationEmailValue();
      EventBus.$emit('closeDelivergoodsdialog', false);
    },
    clearAll () {
      this.$refs.dialogForm.resetFields();
      this.transformationEmailValue();
    },
    // 计算总价
    getTotal ({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        let physical = data.filter(item => item.physicalFlag);
        let physicalNot = data.filter(item => !item.physicalFlag);
        if (index === 0 && physical.length > 0) {
          // 除详情外合计向后移动一列
          if (this.isDetail) {
            sums[index] = '有实物合计';
          } else {
            sums[index + 1] = '有实物合计';
          }
          return;
        }
        if (index === 0 && physicalNot.length > 0) {
          // 除详情外合计向后移动一列
          if (this.isDetail) {
            sums[index] = '无实物合计';
          } else {
            sums[index + 1] = '无实物合计';
          }
          return;
        }
        /**
         * 去掉小计
         */
        const values = data.map(item => item.index !== '小计' && Number(item[column.property]));
        if (column.property === 'unshipQuantity' || column.property === 'amountSum') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return MathAdd(prev, curr);
            } else {
              return prev;
            }
          }, 0).toFixed(2);
        } else {
          if (!this.isDetail && index !== 1) {
            sums[index] = '';
          }
        }
      });
      return sums;
    },
    setCheckBoxHiddenOrVisible ({ row }) {
      if (row.index === '小计') {
        return 'table-column-hidden';
      }
    },
    // 校验·授权邮箱是否为必填地址信息   发运信息 下拉数据
    getSelectData () {
      let params = ['intel_partial_addr_id', 'trade_term', 'packaging_requirements', 'freight_mode', 'CUSTOMS_NOTICE'];
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.addressInfo = data[0].dictDataVOS; // 收货地址
          this.chooseTradeterms = data[1].dictDataVOS; // 贸易术语
          this.packingrequirement = data[2].dictDataVOS; // 包装要求
          this.modeoffreighttransport = data[3].dictDataVOS; // 货运方式
          this.selectEmailUserName = data[4].dictDataVOS; // 发送邮件联系人
        }
      });
    },

    querySearchAsync: debounce(function (forwarderCode) {
      this.isForwarderLoading = true;
      getByForwarderCode({ forwarderCode })
        .then(res => {
          let { status, data } = res.data;
          if (status === '200' && data) {
            this.dialogForm.companyName = data.companyName;
            this.dialogForm.companyPerson = data.contactPerson;
            this.dialogForm.companyTel = data.phoneNumber;
            this.dialogForm.companyEmail = data.email;
            this.dialogForm.companyAddress = data.address;
          } else {
            this.dialogForm.companyName = '';
            this.dialogForm.companyPerson = '';
            this.dialogForm.companyTel = '';
            this.dialogForm.companyEmail = '';
            this.dialogForm.companyAddress = '';
          }
        })
        .finally(() => {
          this.isForwarderLoading = false;
        });
    }),
    authorizedEmailDefault () {
      if (this.$store.state.user.staffEmail) {
        this.currentEamilArr.push(this.$store.state.user.staffEmail);
        this.transformationEmailValue();
      } else {
        this.transformationEmailValue();
      }
    }
  },
  mounted () {
    this.getSelectData();
    this.authorizedEmailDefault();
    this.debouncedValidateEmail = debounce(this.validateEmail);
  },

  watch: {
    product: {
      deep: true,
      immediate: true,
      handler () {
        this.productInfo = this.product;
        this.getHaveAppliedTableDataListMethods();
        let params = [];
        this.product.forEach((item, index) => {
          params.push(item.materialNumber);
        });
        mailboxVerification(params).then(res => {
          if (res.data.status === '200') {
            this.IsBoolean = res.data.data;
          }
        });
        contractgetContractNumberByWarehouse({ contractNum: this.product[0].contractNum }).then(res => {
          if (res.data.status === '200') {
            console.log(res.data.data);
            this.dialogForm.companyName = res.data.data.warehouseName;
            this.dialogForm.companyPerson = res.data.data.warehouseContact;
            this.dialogForm.companyTel = res.data.data.warehouseTel;
            this.dialogForm.companyAddress = res.data.data.warehouseAddress;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contain-physical-title-style{
  margin-top: 0;
  font-size: 17px;
}
.not-contain-physical-title-style{
  font-size: 17px;
}
.summary-row{
  display: flex;
  margin-top: 20px;
   table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #f5f7fa;
    border: 1px solid #ebeef5;
  }

  th,
  td {
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
    font-size: 12px;
    line-height: 18px;
  }
  th,
  td:nth-child(1) {
    width: 11%;
  }
 th,
  td:nth-child(2) {
    width: 40%;
    text-align: right;
  }
 th,
  td:nth-child(3) {
   margin-left: 5%;
  }

  th {
    background-color: #f5f7fa;
    font-weight: bold;
  }

  /* 模仿 el-table 的合计行样式 */
  tfoot tr {
    display: flex;
    align-items: center;
    justify-items: center;
    font-weight: bold;
  }

  /* 调整合计行内文字样式 */
  tfoot td {
    text-align: left;
  }

  /* 调整合计行内第一列空白单元格样式 */
  tfoot td:first-child {
    padding:  16px;
    text-align: center;
  }
}
.el-divider--horizontal::v-deep {
  margin: 10px;
}
::v-deep .emailInput .el-input__inner {
  width: 180px;
}
.el-tag + .el-tag {
    margin-left: 10px;
  }
.addressSelect{
  width: 650px;
}
.error-message {
  color: red;
  font-size: 12px;
}
.inter-send-customs-email-style{
  width: 350px;
  margin: 0px 20px 0px 20px;
}
.inter-send-customs-email-tips-style{
  margin-left: 10px;
}
.table-column-hidden .el-checkbox__input{
  display: none
}
.application-for-combined-shipment-style{
  :deep(.el-form-item__label) {
     width: 220px !important;
  }
}
::v-deep .emailInput .el-input__inner {
  width: 180px;
}
.el-tag + .el-tag {
    margin-left: 10px;
  }
  .error-message {
  color: #f56c6c;
  font-size: 12px;
}

:deep(.el-table__footer-wrapper tbody td.el-table__cell){
  font-weight: 700;
}
.associated-order-number-style{
  :deep(.el-form-item__label) {
     width: 180px !important;
  }
  :deep(.el-form-item__content) {
    margin-left: 180px !important;
  }
}
</style>
